/**
 * Texts of screen E12 · Channels tab and of E7's "Stop copying this channel"
 * (specs/S9-channels-tab/spec.md §4; canvas `GestionCanaux.html`). Provisional until Q3 (tone):
 * French uses "tu". E12 also shows E3's texts (`onboarding.channels.*`: search, empty state,
 * failures, "Copy {{name}}", "Inactive", the removed message) and Home's (`home.channels.*`:
 * status labels, not-set-up hint, setting summary), so a channel reads the same everywhere.
 * Failure texts come from the C2 catalogue by reason code, never from here (I12).
 */
export const channelsFr = {
  title: 'Mes canaux',
  copiedTitle: 'Copiés · {{total}}',
  othersTitle: 'Autres canaux',
  noneCopied: 'Tu ne copies encore aucun canal.',
  copyButton: 'Copier',
  added: '{{name}} est ajouté à tes canaux copiés. Il ne copie rien tant qu’il n’est pas réglé.',
  removedUnnamed:
    'Ce canal ne sera plus copié. Les positions déjà ouvertes par ce canal restent suivies.',
  footer:
    'Pour ne plus copier un canal, ouvre ses réglages. Les positions déjà ouvertes par ce canal restent suivies.',
  stopCopying: {
    button: 'Ne plus copier ce canal',
    title: 'Ne plus copier ce canal ?',
    nextSignals: 'Ses prochains signaux ne seront plus copiés.',
    positions: 'Les positions déjà ouvertes par ce canal restent suivies.',
    confirm: 'Ne plus copier',
    stopping: 'Arrêt…',
    cancel: 'Annuler',
  },
};

/**
 * Shape of the E12 texts. Derived from the French object, like `AccountMessages`: i18next derives
 * the translation keys from it.
 */
export type ChannelsMessages = typeof channelsFr;

/**
 * English texts of E12 and E7's stop action. EN follows `GestionCanaux.html`. Provisional until Q3
 * and Q15.
 */
export const channelsEn: ChannelsMessages = {
  title: 'My channels',
  copiedTitle: 'Copied · {{total}}',
  othersTitle: 'Other channels',
  noneCopied: 'You don’t copy any channel yet.',
  copyButton: 'Copy',
  added: '{{name}} was added to your copied channels. It copies nothing until it is set up.',
  removedUnnamed:
    'This channel will no longer be copied. Positions already opened by that channel keep being tracked.',
  footer:
    'To stop copying a channel, open its settings. Positions already opened by that channel keep being tracked.',
  stopCopying: {
    button: 'Stop copying this channel',
    title: 'Stop copying this channel?',
    nextSignals: 'Its next signals will no longer be copied.',
    positions: 'Positions already opened by this channel keep being tracked.',
    confirm: 'Stop copying',
    stopping: 'Stopping…',
    cancel: 'Cancel',
  },
};
